import { CLOSE_MENU, SHOW_MENU, getAction } from './type.actions';

export const showMenuAction = () => getAction(SHOW_MENU);
export const closeMenuAction = () => getAction(CLOSE_MENU);
